import React, { useMemo, memo } from 'react';

import ReactEcharts from "echarts-for-react";


const IssueChart = ({data}) => {

  const chartData = useMemo(() => {
    let rawData;
    if (!data || data.length < 1) {
      // rawData = [{
      //   org: "0",
      //   per: "0",
      //   spl: "0",
      // }];
      return [{}];
    } else {
      rawData = data;
    }

    let result = [
      { value: Number(rawData[0].per), name: '개인' },
      { value: Number(rawData[0].org), name: '기관' },
      { value: Number(rawData[0].spl), name: '전문가' },
    ];

    if (!rawData[0].total || Number(rawData[0].total) === 0) {
      result.push({ value: 1, name: 'NoData' })
    }

    return result;
  },[data]);


  const options = useMemo(()=>{
    return {
      title: {
        text: '채널이슈',
        left: 'left',
        textStyle: {
          fontSize: 14
        }
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a}<br/>{b}: {d}%'
      },
      legend: {
        orient: 'vertical',
        top: 55,
        left: 0,
        data: ['개인', '기관', '전문가']
      },
      series: [
        {
          type: 'pie',
          radius: ['40%', '70%'],
          center: ['70%', '60%'],
          label: {
            show: false
          },
          silent: chartData.length > 3 ? true : false,
          tooltip: {
            // formatter: '{b}: {d}%',
            formatter: (params)=>{
              if (params.name !== 'NoData') {
                return `${params.name}: ${params.percent}%`;
              }
            },
          },
          // emphasis: {
          //   itemStyle: '#000',
          // },
          animation: chartData.length > 3 ? false : true,
          data: chartData,
        }
      ],
      color: ['#482ef3', '#fc4d00', '#00cc47', '#f5f5f5']
    }
  },[chartData])

  return (
    <ReactEcharts option={options} className="chart pie" style={{height:''}}/>
  )
}

export default memo(IssueChart);